jQuery( document ).ready(function($) {

    $('.tableauchoix_mobile_titre').click(function(){

        $( this ).find('.tableauchoix_mobile_content').toggleClass('tableauchoix_mobile_content_open');
        var src = $( this ).find('.tableauchoix_mobile_chevron').attr('src');
        var newsrc = (src=='/wp-content/themes/index/modules/tableauchoix/img/Chevron_down.png') ? '/wp-content/themes/index/modules/tableauchoix/img/Chevron_up.png' : '/wp-content/themes/index/modules/tableauchoix/img/Chevron_down.png';
        $( this ).find('.tableauchoix_mobile_chevron').attr('src', newsrc );

    });

});